var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshError = function SvgRefreshError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 120,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#refreshError_svg__a)",
    fillRule: "evenodd",
    d: "m100.5 24-80 19.04L40.838 60z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#refreshError_svg__b)",
    fillRule: "evenodd",
    d: "m40.561 60.114-.061.037V89l60-65-60 36.032z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#refreshError_svg__c)",
    fillRule: "evenodd",
    d: "m100.5 24-51 43.238L74 87z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#refreshError_svg__d)",
    d: "m49.5 67.5-9 21.5L56 72.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#refreshError_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M85.5 101.443c0 1.657-11.193 3-25 3s-25-1.343-25-3c0-1.656 11.193-2 25-2s25 .344 25 2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "refreshError_svg__a",
    x1: 47.5,
    x2: 65.5,
    y1: 125.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "refreshError_svg__b",
    x1: 70.5,
    x2: 35.5,
    y1: 71,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D4DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C2C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "refreshError_svg__c",
    x1: 56,
    x2: 152.985,
    y1: 238,
    y2: 14.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "refreshError_svg__d",
    x1: 124,
    x2: 30,
    y1: -8,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E1E5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "refreshError_svg__e",
    width: 54,
    height: 9,
    x: 33.5,
    y: 97.443,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_22858_183294",
    stdDeviation: 1
  })))));
};
export default SvgRefreshError;